var exports = {
  "av": "x24da60e8--c597b9--checkbox-container",
  "kv": "x24da60e8--c597b9--checkbox",
  "q3": "x24da60e8--c597b9--indicator",
  "KD": "x24da60e8--c597b9--checked",
  "z3": "x24da60e8--c597b9--error",
  "kL": "x24da60e8--c597b9--checkbox-content",
  "Pf": "x24da60e8--c597b9--label",
  "h_": "x24da60e8--c597b9--description",
};

module.exports = exports;
